// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"318":"3afe18fc","320":"9ec2a153","953":"932a54ca"}[chunkId] + ".css";
};